import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Inspeccion30Y31Ano2024ProgramaInformatico() {
  return <CategoryPage category="inspeccion30Y31Ano2024ProgramaInformatico" pageTitle="Programas Informaticos" />;
}

export default Inspeccion30Y31Ano2024ProgramaInformatico;
